export function promiseWithTimeout(promise, timeout) {
  var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Timed out';
  // Create a promise that rejects after the specified timeout
  var timeoutPromise = new Promise(function (_, reject) {
    return setTimeout(function () {
      return reject(new Error(errorMessage));
    }, timeout);
  });
  // Use Promise.race to race the provided promise against the timeout promise
  return Promise.race([promise, timeoutPromise]);
}